module.exports = __webpack_public_path__ + "img/group-rec.6e6bef45.svg";